import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const WallisandFutuna: Country = {
    identifier: "WallisandFutuna",
    name: "Wallis and Futuna",
    countryCode: "WF",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇼🇫",
    svgPath: "m 990.83875,500.4344 -0.046,0.023 -0.052,-0.112 0.067,-0.169 0.065,-0.06 0.056,0.133 -0.09,0.185 z m -5.293,2.83 -0.159,0.019 -0.155,-0.038 -0.101,-0.162 0.046,-0.069 0.101,0.032 0.104,0.12 0.172,0.055 -0.008,0.043 z",
}
